import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const CONTAINER = document.getElementById('root');
const ROOT = createRoot(CONTAINER);

ROOT.render(
  // React.StrictMode breaks app in React18
  // <React.StrictMode>
  <BrowserRouter>
    <Route component={App} />
  </BrowserRouter>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
